export const BAR_COLORS = {
  MULDAY: ["#339900", "#FF6600", "#FFFF00"],
  WALK_ONEDAY: ["#339900", "#99CC00", "#FFFF00", "#FF6600"],
  SLEEP_ONEDAY: ["#FFFF00", "#99CC00", "#339900"],
  HEART_ONEDAY: ["#FFFF00", "#99CC00", "#339900"],
  TALK_ONEDAY: ["#FFFF00", "#99CC00", "#339900"],
  SKIN_ONEDAY: [
    "#FF6600",
    "#FF6600",
    "#FF6600",
    "#339900",
    "#339900",
    "#339900",
  ],
};
export const FEEDBACK_BAR_COLORS = {
  SLEEP_TODAY: ["#0070C0", "#408DFF", "#FF33CC"],
  SLEEP_MONTH: ["transparent", "transparent", "transparent"],
  SLEEP_GROUP: ["#0070C0", "#408DFF", "#FF33CC"],
  HEARTBEAT_TODAY: ["#00B050", "#ED7D31", "#FFFF00"],
  HEARTBEAT_MONTH: ["transparent", "transparent", "transparent"],
  HEARTBEAT_GROUP: ["#00B050", "#ED7D31", "#FFFF00"],
  TALK_TODAY: ["#408DFF", "#FF33CC", "#0070C0"],
  TALK_MONTH: ["transparent", "transparent", "transparent"],
  TALK_GROUP: ["#408DFF", "#FF33CC", "#0070C0"],
  SKINTEMP_TODAY: [
    "#ED7D31",
    "#ED7D31",
    "#ED7D31",
    "#00B050",
    "#00B050",
    "#00B050",
  ],
  SKINTEMP_MONTH: [
    "transparent",
    "transparent",
    "transparent",
    "transparent",
    "transparent",
    "transparent",
  ],
  SKINTEMP_GROUP: [
    "#ED7D31",
    "#ED7D31",
    "#ED7D31",
    "#00B050",
    "#00B050",
    "#00B050",
  ],
  KCAL_TODAY: ["#00B050"],
  KCAL_MONTH: ["transparent"],
  KCAL_GROUP: ["#00B050"],
  WALK_TODAY: ["#00B050", "#92D050", "#FFFF00", "#ED7D31"],
  WALK_MONTH: ["transparent", "transparent", "transparent", "transparent"],
  WALK_GROUP: ["#00B050", "#92D050", "#FFFF00", "#ED7D31"],
  SPEED_TODAY: ["#00B050"],
  SPEED_MONTH: ["transparent"],
  SPEED_GROUP: ["#00B050"],
  PITCH_TODAY: ["#00B050"],
  PITCH_MONTH: ["transparent"],
  PITCH_GROUP: ["#00B050"],
  METSH_TODAY: ["#00B050"],
  METSH_MONTH: ["transparent"],
  METSH_GROUP: ["#00B050"],
  FRAIL_GROUP: [
    "#408DFF",
    "#00B050",
    "#FF32CB",
    "#ED7D31",
    "#0070C0",
    "#FEFE05",
  ],
};
